import { Link } from "react-router-dom";

// One set of logo sizes for the whole site (the wordmark is ~9:1, so 20px tall is ~180px wide).
const SIZES = {
  header: "h-[18px] lg:h-5",  // site header: ~160px wide on phones, ~180px on desktop
  admin: "h-5",              // admin login / dashboard: same as the desktop header
  footer: "h-9",             // lockup with tagline: its wordmark matches the header
};

// Official REGERA logo assets (extracted from brand PDF).
export const Logo = ({ className = "", onClick, variant = "wordmark", size = "header", testId = "regera-logo" }) => {
  const src = variant === "lockup" ? "/regera-lockup.png?v=3" : "/regera-wordmark.png?v=3";
  return (
    <Link
      to="/"
      onClick={onClick}
      data-testid={testId}
      className={`inline-flex items-center ${SIZES[size] || SIZES.header} ${className}`}
      aria-label="REGERA — Leading Transformation, home"
    >
      <img
        src={src}
        alt="REGERA — Leading Transformation"
        className="h-full w-auto object-contain select-none [filter:drop-shadow(0_1px_6px_rgba(0,0,0,0.55))]"
        draggable="false"
      />
    </Link>
  );
};

export default Logo;
